module.exports = __webpack_public_path__ + "static/media/progress-img1.2bfd2237.webp";